import { GetImageDimensionsFromURLFragment } from '@dealerportal/utilities';
import Image from 'next/image';
import Link from 'next/link';

type Props = {
  id: string;
  src: string;
  text: string;
  mode: string;
  color: string;
  bgcolor: string;
  addpaddingtotext: string;
};

export function Logo(props: Props) {
  const src = props.src.startsWith('//') ? `https:${props.src}` : props.src;
  const dimensions = GetImageDimensionsFromURLFragment(src);
  return (
    <div style={{ height: '100%' }}>
      <Link href="/" prefetch={false} aria-label="" className="ui-block">
        {props.mode === 'text' && (
          <span
            style={{
              color: props.color,
              backgroundColor: props.bgcolor,
              padding: 'padding: 0px 20px;',
            }}
          >
            {props.text}
          </span>
        )}
        {(props.mode === 'image' || props.mode === 'auto') &&
        dimensions != null ? (
          <Image
            src={src}
            priority={true} // Mark logo as priority loading
            alt={props.text}
            title={props.text}
            style={{ maxWidth: '100%', maxHeight: '100%', height: 'auto' }}
            width={dimensions[0]}
            height={dimensions[1]}
          />
        ) : (
          <img
            src={src}
            alt={props.text}
            title={props.text}
            style={{ maxWidth: '100%', maxHeight: '100%' }}
          />
        )}
      </Link>
    </div>
  );
}

export default Logo;
